import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import AuthorizedApp from "./components/AuthorizedApp";
import authConfig from "./auth_config";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import getStore from "store";
import { LogRocketProvider } from "./context/LogRocketProvider";
import LaunchDarklyProvider from "./components/LaunchDarklyProvider";
import theme from "./theme";

const { store, persistor } = getStore();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={authConfig.domain as string}
      clientId={authConfig.clientId as string}
      authorizationParams={authConfig.authorizationParams}
      // Pop-up ticket windows are a separate JS context; `memory` would force re-login.
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      <LaunchDarklyProvider>
      <LogRocketProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter
              future={{
                // v7_startTransition removed: it causes location updates to lag behind
                // browser navigation, leaving the previous page (e.g. ChatAssistant) visible
                // when navigating away (URL changes but content doesn't update).
                v7_relativeSplatPath: true,
              }}
            >
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <AuthorizedApp />
              </ThemeProvider>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </LogRocketProvider>
      </LaunchDarklyProvider>
    </Auth0Provider>
  </React.StrictMode>
);
